let anchorMenuDropdown = function () {
  document.addEventListener('DOMContentLoaded', function () {

        let dropdownToggle = document.getElementById('anchorMenuButton');
        let dropdownMenu = document.getElementById('anchorMenuDropdown');

        if (!dropdownToggle || !dropdownMenu) {
            // console.warn('Anchor menu elements not found');
            return;
        }

        dropdownToggle.addEventListener('click', function (event) {
            event.stopPropagation();
            console.log('Anchor menu toggle clicked!');

            if (dropdownMenu.classList.contains('show')) {
                dropdownMenu.classList.remove('show');
            } else {
                dropdownMenu.classList.add('show');
            }

            if (dropdownToggle.classList.contains('show')) {
                dropdownToggle.classList.remove('show');
            } else {
                dropdownToggle.classList.add('show');
            }
        });

        dropdownMenu.addEventListener('click', function(event) {
            event.stopPropagation();
        });

        // Close the dropdown if the user clicks outside of it
        document.addEventListener('click', function (event) {
            if (!dropdownToggle.contains(event.target) && !dropdownMenu.contains(event.target)) {
                dropdownMenu.classList.remove('show');
                dropdownToggle.classList.remove('show');
            }
        });
  });
}();